import HTTPClient from '@hs-http-client';
import envService from '@/services/shared/environmentService.js';

import {
  request,
  response,
  error
} from './interceptors';

const client = new HTTPClient({ withCredentials: true })
  .intercepts({
    request,
    response,
    error
  })
  .setBaseUrl(getBaseUrl());

export default {
  login ({ username, password }) {
    return client.get({
      url: '/user/authenticate/cookie/marketplace',
      headers: {
        Authorization: 'Basic ' + btoa(`${username}:${password}`)
      }
    });
  },

  renewAuth () {
    return client.get({
      url: '/user/renew/cookie'
    });
  },

  whoAmI () {
    return client.get({
      url: '/user/whoami'
    });
  },

  logout () {
    return client.get({
      url: '/user/signout/cookie'
    });
  },
  // TODO impl in UI
  setPassword: function (user, newPwd) {
    return client.post({
      url: '/user/request',
      data: {
        command: 'SetPassword',
        setPassword: {
          agencyId: user.agencyId,
          username: user.initials,
          password: newPwd
        }
      }
    });
  }
};

function getBaseUrl () {
  var env = envService.getEnvironment();

  if (env === 'Local') {
    return 'https://userapi.hawksoft-dev.cloud';
  } else if (env === 'Development') {
    return 'https://userapi.hawksoft-dev.cloud';
  } else if (env === 'QA') {
    return 'https://userapi.hawksoft-qa.cloud';
  } else if (env === 'PO') {
    return 'https://userapi.hawksoft-po.cloud';
  } else if (env === 'Production') {
    return 'https://userapi.hawksoft.cloud';
  }

  return '<unable to determine user api url>';
}
